import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Box, Flex } from 'rebass/styled-components';

import Logo from './Logo';
import PleaseWait from './PleaseWait';
import FullLayout from './FullLayout'
import { LoadingMessages } from './icons/LoadingMessages';

const LoadingComponents = styled(Flex)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 300px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const LogoContainer = styled(Box)`
  max-width: 200px;
`;

const LoadableData = styled.div<{ loading?: boolean }>`
  display: ${props => (props.loading ? 'none' : 'block')};
`;

const LoadingScreen: React.FC<{
  bg?: string, color?: string, loading?: boolean, text?: string, textWeight?: string | number, showLogo?: boolean, layoutStyle?: React.CSSProperties
}> = ({ children, bg, color, loading, text, textWeight = "900", showLogo = true, layoutStyle = {} }) => {
  
  return (

    <FullLayout style={{
      opacity: loading ? 1 : 0,
      visibility: loading ? 'visible' : 'hidden',
      transition: 'opacity 0.4s, visibility -0.3s linear 0.5s',
      ...layoutStyle
    }}>
      <Fragment>
        <LoadingComponents>
          {showLogo && (
            <LogoContainer mb={4} mx="auto">
              <Logo dark={false} />
            </LogoContainer>
          )}
          <PleaseWait text={text || ' '} />
        </LoadingComponents>
        {children && <LoadableData loading={loading}>{children}</LoadableData>}
      </Fragment>
    </FullLayout>
  );
};

export default LoadingScreen;
